export const getErrorMessages = (state) => state.exceptionHandler.errorMessages
